import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronLeftDouble14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6.51042 4.52032L5.44976 3.45966L1.91943 6.98999L5.44976 10.5203L6.51042 9.45966L4.04075 6.98999L6.51042 4.52032Z'
      fill='currentColor'
    />
    <path
      d='M11.5104 4.52032L10.4498 3.45966L6.91943 6.98999L10.4498 10.5203L11.5104 9.45966L9.04075 6.98999L11.5104 4.52032Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronLeftDouble14.displayName = 'ChevronLeftDouble14';
export default ChevronLeftDouble14;
